import { parseStoredJson } from './parseStoredJson';

export const MBStorage = {
  async get(key: string, defaultValue?: string): Promise<string | undefined> {
    const value = localStorage.getItem(key);
    return value ?? defaultValue;
  },

  async getJSON<T = object>(key: string, defaultValue?: T): Promise<T | undefined> {
    const value = localStorage.getItem(key);
    return parseStoredJson(value, defaultValue);
  },

  async set(key: string, value: string) {
    localStorage.setItem(key, value);
    const event = new StorageEvent('storage', { key, newValue: value });
    window.dispatchEvent(event);
  },

  async setJSON<T = object>(key: string, value: T) {
    const newValue = JSON.stringify(value);
    localStorage.setItem(key, newValue);
    const event = new StorageEvent('storage', { key, newValue });
    window.dispatchEvent(event);
  },

  async remove(key: string) {
    localStorage.removeItem(key);
    const event = new StorageEvent('storage', { key, newValue: null });
    window.dispatchEvent(event);
  },

  async keys() {
    return Object.keys(localStorage);
  },
};
